<template>
  <div v-if="visible" class="loading-overlay">
    <div class="overlay-content">
      <div class="spinner-border text-light" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <h3 class="text-white mt-3"><strong>{{ text }}...</strong></h3>
      <h5 class="text-white mt-1"><strong>Please wait a moment</strong></h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingOverlayFullscreen",
  props: {
    text: {
      type: String,
      default: "Loading",
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    // Prevent scrolling when overlay is visible
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    // Restore scrolling when the overlay is removed
    document.body.style.overflow = "";
  },
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay-content {
  text-align: center;
}
</style>
